import CommonCreate from "@/components/common/Create"
import ServiceForm from "../forms/ServiceForm"
import { useState } from "react"
import { serviceForm } from "@/utils/objects"

const ServiceCreate = () => {
    const [formProp, setFormProp] = useState(serviceForm)

    return (
        <CommonCreate title="Create new service" resource="auto-service" data={formProp}>
            <ServiceForm mode="create" formProp={formProp} setFormProp={setFormProp} />
        </CommonCreate>
    )
}

export default ServiceCreate